<template>
    <v-flex class="mt-2 row" xs12>
        <v-icon left medium>{{icon}}</v-icon>
        <span class="font-weight-bold" style="color: black; font-size: 17px;">
                           {{text}}</span>
        <span v-if="description" class="font-weight-bold ml-1" style="color: red; font-size: 14px;">{{description}}</span>
    </v-flex>
</template>

<script>
    export default {
        name: "ConfirmationHeaderText",
        props: {
            text: {
                type: [String, Number, Boolean],
                default: false
            },
            description: {
                type: [String, Number, Boolean],
                default: false
            },
            icon: {
                type: [String],
                default: ''
            },
        },
    }
</script>
